<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_2762_9305)">
      <path
        d="M3.33337 9.52428C2.09913 10.0688 1.33337 10.8275 1.33337 11.6667C1.33337 13.3236 4.31814 14.6667 8.00004 14.6667C11.6819 14.6667 14.6667 13.3236 14.6667 11.6667C14.6667 10.8275 13.9009 10.0688 12.6667 9.52428M12 5.33337C12 8.04251 9.00004 9.33337 8.00004 11.3334C7.00004 9.33337 4.00004 8.04251 4.00004 5.33337C4.00004 3.12423 5.7909 1.33337 8.00004 1.33337C10.2092 1.33337 12 3.12423 12 5.33337ZM8.66671 5.33337C8.66671 5.70156 8.36823 6.00004 8.00004 6.00004C7.63185 6.00004 7.33337 5.70156 7.33337 5.33337C7.33337 4.96518 7.63185 4.66671 8.00004 4.66671C8.36823 4.66671 8.66671 4.96518 8.66671 5.33337Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2762_9305">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
